// extracted by mini-css-extract-plugin
export default {"form-error--table-layout":"formfield_form-error--table-layout__iVjxz"};